import React, { useState, useContext, useMemo } from 'react';
import { FieldContext, MetadataEntryContext } from '../../hooks/Contexts';
import SortableItem from '../common/DnD/SortableItem';
import OptionEdit from './OptionEdit';
import OptionControls from './OptionControls';
import MetaContent from '../metadata/MetaContent';

const OptionListItem = ({ option, id }) => {
  const [editing, setEditing] = useState(false);
  const [disableDrag, setDisableDrag] = useState(false);
  const { field } = useContext(FieldContext);
  const metaEntries = useContext(MetadataEntryContext);
  const { metadata_contents } = option;
  const toggleEdit = () => {
    setEditing(!editing);
  };

  const matchContentsByEntry = () => {
    const noContent = { description: '' };
    let entryContents = [];
    if (metaEntries) {
      metaEntries.forEach(function (e, i, arr) {
        let entryContent =
          metadata_contents.find((c) => c.metadata_entry_id === e.id) ||
          noContent;

        entryContents.push([e, entryContent]);
      });
    }
    return entryContents;
  };

  // save a little browser memory
  const contentsByEntry = useMemo(
    () => matchContentsByEntry(),
    [metaEntries.length, metadata_contents]
  );

  return (
    <SortableItem
      id={id}
      className={'option' + (editing ? ' editing' : '')}
      disabled={editing || field.alpha || disableDrag}
    >
      {editing ? (
        <OptionEdit
          option={option}
          editing={editing}
          toggleEdit={toggleEdit}
          contentsByEntry={contentsByEntry}
        />
      ) : (
        <div className='cargo' id={option.id}>
          <div className='name'>
            <div className='content'>
              <strong>Name:</strong>
              <span>{option.name}</span>
            </div>

            <OptionControls
              field={field}
              option={option}
              editing={editing}
              toggleEdit={toggleEdit}
            />
          </div>

          <div className='meta val'>
            <strong>Value:</strong>
            {option.value}
          </div>

          {field.type != 'checkbox' && metaEntries.length > 0 && (
            <MetaContent
              option={option}
              editing={editing}
              entryContent={contentsByEntry}
              setDisableDrag={setDisableDrag}
            />
          )}
        </div>
      )}
    </SortableItem>
  );
};

export default OptionListItem;
